import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.SeniorManagers";
import { SeniorManagersDto } from "../../../../Model/Dto/EmploymentEquity/Plan/EESeniorManagers";

export const SeniorManagersService = {
    GetSeniorManagersInformation: (scorecardId: string) : Promise<AxiosResponse<SeniorManagersDto.SeniorManagersDto>> => axiosCoreInstance.get(`${ApiUrls.GetSeniorManagersInformation}?ScorecardId=${scorecardId}`),
    SaveSeniorManagersInformation: (request: SeniorManagersDto.SeniorManagersDto) : Promise<AxiosResponse<SeniorManagersDto.SeniorManagersDto>> => axiosCoreInstance.post(ApiUrls.SaveSeniorManagersInformation, request)
}